// Индикаторы удара: бегунок ходит туда-обратно, игрок останавливает его тапом.
// Значение — по положению в момент тапа; клиент присылает его серверу, исход считает сервер.

/** Треугольная волна 0 → 1 → 0 с периодом periodMs. */
export function pingPong(elapsedMs: number, periodMs: number): number {
  const phase = ((elapsedMs % periodMs) + periodMs) % periodMs;
  const x = phase / periodMs;
  return 1 - Math.abs(x * 2 - 1);
}

/** Сила: полный цикл 1,4 с. Выше 0,8 — перебор (риск промаха), подсвечиваем красным. */
export const POWER_PERIOD_MS = 1400;
export const POWER_OVERHIT = 0.8;
export const powerAt = (elapsedMs: number) => pingPong(elapsedMs, POWER_PERIOD_MS);

/** Точность: стрелка бегает за 1 с; чем ближе к центру — тем точнее (центр = 1, края = 0). */
export const ACCURACY_PERIOD_MS = 1000;
export const needleAt = (elapsedMs: number) => pingPong(elapsedMs, ACCURACY_PERIOD_MS);
export const accuracyFromNeedle = (needle: number) =>
  Math.max(0, Math.min(1, 1 - Math.abs(needle - 0.5) * 2));

/** Те же пороги, что в движке (balance.ts): PERFECT ≥ 0,9, GOOD ≥ 0,6. Ширина зон на шкале — для отрисовки. */
export const PERFECT_FROM = 0.9;
export const GOOD_FROM = 0.6;
export const PERFECT_HALF_WIDTH = (1 - PERFECT_FROM) / 2; // ±0,05 от центра шкалы
export const GOOD_HALF_WIDTH = (1 - GOOD_FROM) / 2; // ±0,2
